<template>
  <div
    class="lg:px-12 md:px-12 px-4 lg:py-12 md:py-12 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 mt-20"
  >
    <div class="cust-88per sm-full mx-auto">
      <p
        class="title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pl-2 md:pl-2 pl-6 mx-auto text-center"
      >
        Partners
      </p>
      <div
        class="flex flex-wrap align-middle items-center lg:py-12 md:py-12 py-6"
      >
        <swiper class="swiper" :options="swiperOptions">
          <!-- v-for="(item, index) in 6" :key="index" -->
          <swiper-slide
            v-for="(item, index) in partners"
            :key="'item -' + index"
          >
            <img
              :src="item.image"
              alt="Avatar"
              class="flex md:h-32 lg:h-32 md:w-32 lg:w-32 w-12 object-contain custaspectratio sm-partner-w"
              :class="item.id === 1 ? 'custwidth' : ' '"
            />
          </swiper-slide>
          <!-- <div class="swiper-pagination cust-posi" slot="pagination"></div> -->
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },

        breakpoints: {
          1600: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
          575: {
            slidesPerView: 2,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },
      partners: [
        // {
        //   image: require("@/assets/images/PartnerLogos/CanSupport-logo.png"),
        // },
        // {
        //   image: require("@/assets/images/CGNEW/aajicare.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo1.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/image4.png"),
        // },
        {
          id: 1,
          image: require("@/assets/images/CSLogo.png"),
        },
        {
          id: 2,
          image: require("@/assets/images/partner/image5.png"),
        },
        {
          id: 3,
          image: require("@/assets/images/partner/image14.png"),
        },

        {
          id: 4,
          image: require("@/assets/images/partner/image7.png"),
        },
        {
          id: 5,
          image: require("@/assets/images/partner/image10.png"),
        },
        {
          id: 6,
          image: require("@/assets/images/partner/image8.png"),
        },
        // {
        //   id: 7,
        //   image: require("@/assets/images/partner/toward Equal.png"),
        // },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style>
.custaspectratio {
  aspect-ratio: 3/2;
}
.custwidth {
  width: 180px !important;
  height: 130px;
}
@media (max-width: 640px) {
  .custwidth {
    width: 200px !important;
    height: 90px;
  }
}
</style>
